<div class="modal-header">
    <h4 class="modal-title pull-left">{{ 'controls.auditSampler.title' | transloco }}</h4>
</div>
<div class="modal-body">
    @if (formGroup) {
        <form [formGroup]="formGroup">
            <div class="row">
                <div class="col-6 left-block">
                    <div class="form-group">
                        <label>{{ 'controls.auditSampler.sampleTypeLabel' | transloco }}</label>
                        <ng-select
                            bindValue="ID"
                            bindLabel="Name"
                            [items]="sampleTypes"
                            [clearable]="false"
                            [(ngModel)]="sampleModel.sampleType"
                            [ngModelOptions]="{ standalone: true }"
                        >
                        </ng-select>
                    </div>
                    <div
                        class="form-group"
                        [hidden]="sampleModel.sampleType != sampleTypeEnum.number"
                    >
                        <label>{{ 'controls.auditSampler.testPopulationSizeLabel' | transloco }}</label>
                        <input
                            type="number"
                            min="1"
                            class="form-control form-control-sm"
                            formControlName="testPopulationSize"
                        />
                    </div>
                    <div class="row" [hidden]="sampleModel.sampleType != sampleTypeEnum.date">
                        <div class="form-group col">
                            <label>{{ 'controls.auditSampler.startDateLabel' | transloco }}</label>
                            <date-input formControlName="startDate"></date-input>
                        </div>
                        <div class="form-group col">
                            <label>{{ 'controls.auditSampler.endDateLabel' | transloco }}</label>
                            <date-input formControlName="endDate"></date-input>
                        </div>
                    </div>
                </div>
                <div class="col-6 right-block">
                    <div class="form-group">
                        <label>{{ 'controls.auditSampler.seedNumberLabel' | transloco }}</label>
                        <input
                            type="number"
                            class="form-control form-control-sm"
                            formControlName="seedNumber"
                        />
                    </div>
                    <div class="form-group">
                        <label>{{ 'controls.auditSampler.numberOfTestSamplesLabel' | transloco }}</label>
                        <input
                            type="number"
                            class="form-control form-control-sm"
                            formControlName="numberOfSamples"
                        />
                    </div>
                </div>
            </div>

            @if (allValidations.length > 0) {
                <div class="form-group-separator"></div>
                <div class="red">
                    @for (validation of allValidations; track validation) {
                        <p>
                            {{ validation }}
                        </p>
                    }
                </div>
            }

            @if (generatedSamples) {
                <div class="form-group-separator"></div>
                <div class="form-group">
                    <label>{{ 'controls.auditSampler.resultLabel' | transloco }}</label>
                    <textarea
                        class="form-control form-control-sm"
                        readonly
                        [(ngModel)]="generatedSamples"
                        [ngModelOptions]="{ standalone: true }"
                        inputTooltip
                    ></textarea>
                </div>
            }
        </form>
    }
</div>
<div class="modal-footer">
    <button class="btn btn-cerrix" (click)="generate()" [disabled]="isGenerating">
        {{ 'controls.auditSampler.generateBtn' | transloco }}
        @if (isGenerating) {
            <i class="fas fa-circle-notch fa-spin ms-2"></i>
        }
    </button>
    <button class="btn btn-dark" (click)="modalRef.hide()">{{ 'controls.auditSampler.closeBtn' | transloco }}</button>
</div>
